<template>
    <adminTable
      :hideSeachButton="false"
      :tableLoading="tableLoading"
      :totalList="totalList"
      v-model:page="page"
      v-model:limit="limit"
      v-model:searchForm="searchForm"
      :tableData="tableData"
      @search="getList"
    >
      <template v-slot:form-inline-items>
        <el-form-item label="">
          <el-input
            v-model="searchForm.username"
            placeholder="请输入用户名"
            clearable
          />
        </el-form-item>
        <el-form-item label="">
          <el-input
            v-model="searchForm.phone"
            placeholder="请输入手机号"
            clearable
          />
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="searchForm.is_test"
            placeholder="请选择账号类型"
            clearable
          >
            <el-option
              v-for="item in accountTypeEnums"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="searchForm.is_vip"
            placeholder="是否VIP"
            clearable
          >
            <el-option
              v-for="item in booleanEnums"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </template>
      <template v-slot:query-button-right>
        <el-button
          type="primary"
          icon="CirclePlus"
          @click="editItem('add', {})"
          v-permission
          >添加</el-button
        >
      </template>
      <template v-slot:table>
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="uid" label="用户ID" width="130" />
        <el-table-column prop="username" label="用户名" width="130" />
        <el-table-column prop="phone" label="手机号" width="130" />
        <el-table-column prop="is_test" label="账号类型" width="130">
        <template #default="scope">
          {{ getLabelByVal(scope.row.is_test, accountTypeEnums) }}
        </template>
      </el-table-column>
        <el-table-column prop="next" label="幸运抽奖预设" width="120">
          <template #default="scope">
            {{ raffleOptions.find(item => item.id == scope.row.next)?.title || '--' }}
            <span v-if="raffleOptions.find(item => item.id == scope.row.next)">
              ({{ raffleOptions.find(item => item.id == scope.row.next)?.words || '--' }})
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="next_prize" label="抽大奖预设" width="120">
          <template #default="scope">
            {{ bigRaffleOptions.find(item => item.id == scope.row.next_prize)?.title || '--' }}
            <span v-if="bigRaffleOptions.find(item => item.id == scope.row.next_prize)">
              ({{ bigRaffleOptions.find(item => item.id == scope.row.next_prize)?.money || '--' }})
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="yu" label="御" width="100" />
        <el-table-column prop="xiang" label="享" width="100" />
        <el-table-column prop="zhen" label="臻" width="100" />
        <el-table-column prop="pin" label="品" width="100" />
        <el-table-column prop="xing" label="行" width="100" />
        <el-table-column prop="wen" label="稳" width="100" />
        <el-table-column prop="zhi" label="致" width="100" />
        <el-table-column prop="yuan" label="远" width="100" />
        <el-table-column prop="create_at" label="创建时间" width="130" />
        <el-table-column prop="update_at" label="更新时间" width="130" />
        <el-table-column
          label="操作"
          fixed="right"
          width="200"
          v-if="currentUser.role == 0"
        >
          <template #default="scope">
            <el-button
              type="primary"
              icon="Edit"
              v-permission
              @click="editItem('edit', scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="Delete"
              v-permission
              @click="deleteAction(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </template>
      <el-dialog v-model="dialogFlag" title="编辑/新增" width="1100">
        <editPop :key="editRow" ref="editFormRef" :item="editRow" />
  
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="dialogFlag = false">关闭</el-button>
            <el-button type="primary" @click="submitForm"> 保存 </el-button>
          </div>
        </template>
      </el-dialog>
    </adminTable>
  </template>
  
  <script setup>
  import { ref, getCurrentInstance, onMounted } from "vue";
  import editPop from "./components/collectWords/editPop.vue";
  import { ElMessage, ElMessageBox } from "element-plus";
  import { accountTypeEnums, booleanEnums, getLabelByVal } from "../../config/enums";
  
  const dialogFlag = ref(false);
  const editFormRef = ref(false);
  const editRow = ref({});
  const formType = ref("add");
  const searchForm = ref({
    username: null,
    phone: null,
    is_test: null,
    is_vip: null,
  });

  onMounted(() => {
    getList();
    loadRaffles();
    loadBigRaffles();
  });
  
  const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  const { proxy } = getCurrentInstance();
  const raffleOptions = ref([]);
  const bigRaffleOptions = ref([]);
  const loadRaffles = async () => {
    const res = await proxy.$http({
      method: "get",
      url: "/Raffle/getRaffleLists",
      params: {
        page: 1,
        limit: 1000,
      },
    });
    if (res.code === 0) {
      raffleOptions.value = res.data.data || [];
    }
  };
  const loadBigRaffles = async () => {
    const res = await proxy.$http({
      method: "get",
      url: "/RaffleBig/getRaffleLists",
      params: {
        page: 1,
        limit: 1000,
      },
    });
    if (res.code === 0) {
      bigRaffleOptions.value = res.data.data || [];
    }
  };
  
  const page = ref(1);
  const limit = ref(10);
  const totalList = ref(0);
  const tableLoading = ref(false);
  const tableData = ref([]);
  const getList = async () => {
    tableLoading.value = true;
    const res = await proxy.$http({
      type: "get",
      url: "/Words/getWordsLists",
      params: {
        page: page.value,
        limit: limit.value,
        ...searchForm.value,
      },
      });
    tableLoading.value = false;
    if (res.code == 0) {
      tableData.value = res.data.data;
      totalList.value = res.data.total;
    }
  };
  
  const editItem = (type, row) => {
    formType.value = type;
    editRow.value = row;
    dialogFlag.value = true;
  };
  
  const deleteAction = (row) => {
    ElMessageBox.confirm("是否删除?", "Warning", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        const res = await proxy.$http({
          method: "get",
          url: "/Words/deleteWords?id=" + row.id,
        });
        if (res.code == 0) {
          getList();
        }
        ElMessage({
          type: "success",
          message: res.msg,
        });
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "取消删除",
        });
      });
  };
  
  const submitForm = async () => {
    const url = formType.value == "add" ? "Words/addWords" : "Words/updateWords";
    const data = editFormRef.value.form;
    if (formType.value == "add") {
      data.id = null;
    }
    const res = await proxy.$http({
      method: "post",
      url: url,
      data: {
        phone: data.phone,
        yu: data.yu,
        xiang: data.xiang,
        zhen: data.zhen,
        pin: data.pin,
        xing: data.xing,
        wen: data.wen,
        zhi: data.zhi,
        yuan: data.yuan,
        id: data.id,
        next: data.next,
        next_prize: data.next_prize,
      },
    });
  
    if (res.code == 0) {
      dialogFlag.value = false;
      getList();
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      dialogFlag.value = false;
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
  };
  </script>
  
  <style lang="less" scoped></style>
  
